const SET_INPUTS_IS_OPEN = 'SET_INPUTS_IS_OPEN';

export {
    SET_INPUTS_IS_OPEN,
};



// WEBPACK FOOTER //
// ./src/containers/Inputs/constants.js